import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {EventComment, EventCommentRequest, EventItem, EventSearchParams} from '@communication/_common/models/events.models';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';

// <editor-fold desc="Publications list">
export const LoadList = createAction(
    '[Publications] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Publications] Load List Success',
    props<{ payload: { items: EventItem[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Publications] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Publications] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Publications] Set Filter',
    props<{ payload: EventSearchParams }>()
);

export const SetLoading = createAction(
    '[Publications] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Publications] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

// </editor-fold desc="Publications list">

// <editor-fold desc="Publication item">

export const UpdateItemSuccess = createAction(
    '[Publications] Update Item Success',
    props<{ payload: EventItem }>()
);

export const DeleteItem = createAction(
    '[Publications] Delete Item',
    props<{ payload: EventItem }>()
);

export const DeleteItemSuccess = createAction(
    '[Publications] Delete Item Success',
    props<{ payload: EventItem }>()
);

export const SetOpenedItem = createAction(
    '[Publications] Set Opened Item',
    props<{ payload: EventItem }>()
);

export const ClearOpenedItem = createAction(
    '[Publications] Clear Opened Item'
);

export const UpdateOpenedItem = createAction(
    '[Publications] Update Opened Item',
    props<{ payload: EventItem }>()
);

// </editor-fold desc="Publication item">

// <editor-fold desc="Publication comments">
export const LoadComments = createAction(
    '[Publications] Load Comments',
    props<{ payload: { eventId: string, loading: DahLoadingType } }>()
);

export const LoadCommentsSuccess = createAction(
    '[Publications] Load Comments Success',
    props<{ payload: { comments: EventComment<any>[], pagination: DahPaginationModel } }>()
);

export const LoadCommentsFailure = createAction(
    '[Publications] Load Comments Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SendComment = createAction(
    '[Publications] Send Comment',
    props<{ payload: { event: EventItem, comment: EventCommentRequest } }>()
);

export const SendCommentSuccess = createAction(
    '[Publications] Send Comment Success',
    props<{ payload: EventComment<any> }>()
);

export const SendCommentFailure = createAction(
    '[Publications] Send Comment Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const UpdateCommentSuccess = createAction(
    '[Publications] Update Comment Success',
    props<{ payload: EventComment<any> }>()
);

export const DeleteComment = createAction(
    '[Publications] Delete Comment',
    props<{ payload: { event: EventItem, comment: EventComment<any> } }>()
);

export const DeleteCommentSuccess = createAction(
    '[Publications] Delete Comment Success',
    props<{ payload: EventComment<any> }>()
);

export const CheckAndChangeLastComment = createAction(
    '[Publications] Check And Change Last Comment',
    props<{ payload: { event: EventItem, comment: EventComment<any> } }>()
);

export const SetCommentItemsLoading = createAction(
    '[Publications] Set Comment Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const SetCommentLike = createAction(
    '[Publications] Set Comment Like',
    props<{ payload: { event: EventItem, comment: EventComment<any> } }>()
);

// </editor-fold desc="Publication comments">

export const SetInitialState = createAction(
    '[Publications] Set Initial State'
);
